// UI filter state + responsive legend helpers.

import { useEffect, useState } from "react";

export function useReportsFilters() {
    // Tab Controls
    const [activeTab, setActiveTab] = useState("insights");

    // Question display filter - default to first question
    const [selectedQuestionId, setSelectedQuestionId] = useState("");

    // Chart detail table open/close map (key -> boolean)
    const [openChartTables, setOpenChartTables] = useState({});

    // Legend direction flips below 768px viewport width.
    const [legendDirection, setLegendDirection] = useState("row");
    const legendBreakpoint = 768;

    useEffect(() => {
        const handleResize = () => {
            const newDirection =
                window.innerWidth < legendBreakpoint ? "column" : "row";
            setLegendDirection((prev) =>
                prev !== newDirection ? newDirection : prev,
            );
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getLegendPosition = (itemCount = 1) => {
        return legendDirection === "row"
            ? { translateY: 70 }
            : { translateY: Math.max(itemCount * 30 + 20, 50) };
    };

    const getBottomMargin = (itemCount = 1) => {
        return legendDirection === "row"
            ? 70
            : Math.max(itemCount * 30 + 20, 50);
    };

    const getBottomMarginNoLegend = () => 50;

    const getLegendItemWidth = () => {
        return legendDirection === "row" ? 130 : 100;
    };

    return {
        activeTab,
        setActiveTab,
        selectedQuestionId,
        setSelectedQuestionId,
        openChartTables,
        setOpenChartTables,
        legendDirection,
        setLegendDirection,
        getLegendPosition,
        getBottomMargin,
        getBottomMarginNoLegend,
        getLegendItemWidth,
    };
}
